import script from "./modelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./modelDialog.vue?vue&type=script&setup=true&lang=js"

import "./modelDialog.vue?vue&type=style&index=0&id=8fbdf854&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fbdf854"]])

export default __exports__